/** Server response for /notification/{auth|no-auth}/:notificationId */

export let NotificationType = /*#__PURE__*/function (NotificationType) {
  NotificationType["Relationship"] = "relationship";
  NotificationType["Invoice"] = "invoice";
  NotificationType["Account"] = "account";
  NotificationType["Business"] = "business";
  return NotificationType;
}({});
export let BusinessNotificationType = /*#__PURE__*/function (BusinessNotificationType) {
  BusinessNotificationType["ReminderConnectKyc"] = "ReminderConnectKyc";
  BusinessNotificationType["PayoutReconciliation"] = "payoutReconciliation";
  BusinessNotificationType["PaymentsDigest"] = "PaymentsDigest";
  BusinessNotificationType["AccountantJoinRequest"] = "AccountantJoinRequest";
  BusinessNotificationType["AccountantJoinRequestApproved"] = "AccountantJoinRequestApproved";
  BusinessNotificationType["AccountantJoinRequestRejected"] = "AccountantJoinRequestRejected";
  BusinessNotificationType["AccountantPmAdded"] = "AccountantPmAdded";
  BusinessNotificationType["ReferredVendorCreditsAwarded"] = "ReferredVendorCreditsAwarded";
  BusinessNotificationType["ReferringVendorCreditsAwarded"] = "ReferringVendorCreditsAwarded";
  BusinessNotificationType["PayoutDepositedVendor"] = "PayoutDepositedVendor";
  BusinessNotificationType["PayoutFailedVendor"] = "PayoutFailedVendor";
  BusinessNotificationType["PayoutDepositedRetryVendor"] = "PayoutDepositedRetryVendor";
  BusinessNotificationType["ManualMicroDepositInitiatedCustomer"] = "ManualMicroDepositInitiatedCustomer";
  BusinessNotificationType["ManualMicroDepositInitiatedVendor"] = "ManualMicroDepositInitiatedVendor";
  BusinessNotificationType["AdditionalPaymentProcessorInformationNeeded"] = "AdditionalPaymentProcessorInformationNeeded";
  BusinessNotificationType["TaxForm1099Vendor"] = "TaxForm1099Vendor";
  BusinessNotificationType["IntegrationAutomaticallyDisconnected"] = "IntegrationAutomaticallyDisconnected";
  BusinessNotificationType["ReconnectMailboxType"] = "ReconnectMailboxType";
  BusinessNotificationType["KybApprovedRequiresIdentity"] = "KYBApprovedRequiresIdentity";
  BusinessNotificationType["KybApprovedWithIdentity"] = "KYBApprovedWithIdentity";
  return BusinessNotificationType;
}({});
export let AccountNotificationType = /*#__PURE__*/function (AccountNotificationType) {
  AccountNotificationType["CapitalizedEmailVerification"] = "EmailVerification";
  AccountNotificationType["EmailVerification"] = "emailVerification";
  AccountNotificationType["EmailUpdate"] = "emailUpdate";
  AccountNotificationType["OneTimeAccess"] = "oneTimeAccess";
  AccountNotificationType["ResetPasswordRequested"] = "resetPasswordRequested";
  AccountNotificationType["InviteToJoinBusiness"] = "inviteToJoinBusiness";
  AccountNotificationType["InviteTeamMember"] = "InviteTeamMember";
  AccountNotificationType["VerificationPassed"] = "verificationPassed";
  AccountNotificationType["ContinueVendorOnboarding"] = "ContinueVendorOnboarding";
  AccountNotificationType["PasswordResetSuccessfully"] = "passwordResetSuccessfully";
  return AccountNotificationType;
}({});
export let InvoiceNotificationType = /*#__PURE__*/function (InvoiceNotificationType) {
  InvoiceNotificationType["InvoiceIssuedOLD"] = "invoiceIssued";
  InvoiceNotificationType["InvoiceIssued"] = "InvoiceIssued";
  InvoiceNotificationType["InvoiceIssuedForPayment"] = "invoiceIssuedForPayment";
  InvoiceNotificationType["InvoiceIssuedRequiresApproval"] = "invoiceIssuedRequiresApproval";
  InvoiceNotificationType["PaidCustomer"] = "paidCustomer";
  InvoiceNotificationType["PaymentFailed"] = "paymentFailed";
  InvoiceNotificationType["PaymentFailedCustomer"] = "PaymentFailedCustomer";
  InvoiceNotificationType["PaymentFailedVendor"] = "PaymentFailedVendor";
  InvoiceNotificationType["PaymentProcessingCustomer"] = "paymentProcessingCustomer";
  InvoiceNotificationType["PaymentProcessingVendor"] = "paymentProcessingVendor";
  InvoiceNotificationType["UpcomingForImmediatePayment"] = "upcomingForImmediatePayment";
  InvoiceNotificationType["ExtensionRequested"] = "extensionRequested";
  InvoiceNotificationType["OneOffIssuedRequiresApproval"] = "oneOffIssuedRequiresApproval";
  InvoiceNotificationType["InvoiceApproved"] = "InvoiceApproved";
  InvoiceNotificationType["ApproveInvoice"] = "ApproveInvoice";
  InvoiceNotificationType["ProcessingActionPending"] = "processingActionPending";
  InvoiceNotificationType["InvoiceRefundedVendor"] = "InvoiceRefundedVendor";
  InvoiceNotificationType["InvoiceRefundFailedVendor"] = "InvoiceRefundFailedVendor";
  InvoiceNotificationType["InvoiceRefundedCustomer"] = "InvoiceRefundedCustomer";
  InvoiceNotificationType["InvoicePaymentStoppedCustomer"] = "InvoicePaymentStoppedCustomer";
  InvoiceNotificationType["InvoicePaymentStoppedVendor"] = "InvoicePaymentStoppedVendor";
  InvoiceNotificationType["InvoicePaymentResumedVendor"] = "InvoicePaymentResumedVendor";
  InvoiceNotificationType["InvoicePaymentResumedCustomer"] = "InvoicePaymentResumedCustomer";
  InvoiceNotificationType["PaymentDisputedVendor"] = "PaymentDisputedVendor";
  InvoiceNotificationType["ApproveTeamMemberInvitation"] = "ApproveTeamMemberInvitation";
  return InvoiceNotificationType;
}({});
export let RelationshipNotificationType = /*#__PURE__*/function (RelationshipNotificationType) {
  RelationshipNotificationType["Added"] = "added";
  RelationshipNotificationType["AddedWithCustomText"] = "addedWithCustomText";
  RelationshipNotificationType["AdHocChargeAdded"] = "adHocChargeAdded";
  RelationshipNotificationType["AdHocChargeCanceled"] = "adHocChargeCanceled";
  RelationshipNotificationType["AdHocChargeApprovalReminder"] = "adHocChargeApprovalReminder";
  RelationshipNotificationType["AgreementAmendmentsReminder"] = "agreementAmendmentsReminder";
  RelationshipNotificationType["AgreementApprovalReminder"] = "agreementApprovalReminder";
  RelationshipNotificationType["AgreementApprovalReminderManual"] = "agreementApprovalReminderManual";
  RelationshipNotificationType["RelationshipAutoPriceIncreaseVendor"] = "RelationshipAutoPriceIncreaseVendor";
  RelationshipNotificationType["RelationshipAutoPriceIncreaseCustomer"] = "RelationshipAutoPriceIncreaseCustomer";
  RelationshipNotificationType["Amended"] = "amended";
  RelationshipNotificationType["AmendedNoClientApproval"] = "amendedNoClientApproval";
  RelationshipNotificationType["Approved"] = "approved";
  RelationshipNotificationType["RelationshipApprovedVendor"] = "RelationshipApprovedVendor";
  RelationshipNotificationType["ApprovedAmendments"] = "approvedAmendments";
  RelationshipNotificationType["RelationshipAmendmentsApprovedVendor"] = "RelationshipAmendmentsApprovedVendor";
  RelationshipNotificationType["RelationshipApprovedCustomer"] = "RelationshipApprovedCustomer";
  RelationshipNotificationType["ClientUnresponsiveAmendmentsApproval"] = "clientUnresponsiveAmendmentsApproval";
  RelationshipNotificationType["ClientUnresponsivePaymentMethod"] = "clientUnresponsivePaymentMethod";
  RelationshipNotificationType["ClientUnresponsiveSigning"] = "clientUnresponsiveSigning";
  RelationshipNotificationType["CreditApplied"] = "creditApplied";
  RelationshipNotificationType["ExistingCustomer"] = "existingCustomer";
  RelationshipNotificationType["ExistingCustomerWithText"] = "existingCustomerWithText";
  RelationshipNotificationType["RelationshipNewProposalCustomer"] = "RelationshipNewProposalCustomer";
  RelationshipNotificationType["RelationshipDirectLink"] = "RelationshipDirectLink";
  RelationshipNotificationType["MicroDepositCompletionReminder"] = "microDepositCompletionReminder";
  RelationshipNotificationType["MicroDepositProcessInitiated"] = "microDepositProcessInitiated";
  RelationshipNotificationType["New"] = "new";
  RelationshipNotificationType["NewWithText"] = "newWithText";
  RelationshipNotificationType["RelationshipSigning"] = "RelationshipSigning";
  RelationshipNotificationType["SingleUseApproval"] = "singleUseApproval";
  RelationshipNotificationType["Terminated"] = "terminated";
  RelationshipNotificationType["RelationshipUpdated"] = "RelationshipUpdated";
  RelationshipNotificationType["RelationshipUpdatedWithChanges"] = "RelationshipUpdatedWithChanges";
  RelationshipNotificationType["AmendmentsAutoApprovalReminder"] = "AmendmentsAutoApprovalReminder";
  RelationshipNotificationType["ApproveAmendment"] = "ApproveAmendment";
  RelationshipNotificationType["RequestPaymentMethod"] = "RequestPaymentMethod";
  RelationshipNotificationType["AmendmentsAutoApproved"] = "AmendmentsAutoApproved";
  RelationshipNotificationType["RelationshipTerminated"] = "RelationshipTerminated";
  RelationshipNotificationType["RelationshipReadyForReview"] = "RelationshipReadyForReview";
  RelationshipNotificationType["ReviewProposalLink"] = "ReviewProposalLink";
  RelationshipNotificationType["ProposalApprovalManualReminder"] = "ProposalApprovalManualReminder";
  RelationshipNotificationType["RelationshipPracticeManagementFailedItems"] = "RelationshipPracticeManagementFailedItems";
  RelationshipNotificationType["RelationshipPracticeManagementContactMatchFailure"] = "RelationshipPracticeManagementContactMatchFailure";
  RelationshipNotificationType["ProposalNotSignedVendor"] = "ProposalNotSignedVendor";
  return RelationshipNotificationType;
}({});